/* ============================================================
   Snack Attack theme JS
   1. Mobile nav drawer (focus trap, ESC)
   2. Product-card video engine (scroll-driven, one at a time)
   3. Cart drawer + AJAX line edits
   4. PDP: gallery, variant picker, quantity, add-to-cart states
   5. Closure guide modal (+ select-a-closure handoff)
   6. Recently viewed (localStorage)
   7. Newsletter signup states, legal ToC, copy buttons, share
   ============================================================ */
(function () {
  'use strict';
  var SA = window.SnackAttack || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var n = (cents / 100);
    var s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return '$' + s;
  }
  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- generic focus trap ---------- */
  function trap(el) {
    return function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', el)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
  }

  /* ============================================================
     1. MOBILE NAV
     ============================================================ */
  function initMobileNav() {
    var nav = $('.sa-nav'); if (!nav) return;
    var actions = $('.sa-nav-actions', nav);
    var links = $$('.sa-nav-links a', nav);
    if (!actions || $('.sa-nav-burger', actions)) return;

    var burger = document.createElement('button');
    burger.className = 'sa-nav-burger';
    burger.setAttribute('aria-label', 'Open menu');
    burger.setAttribute('aria-expanded', 'false');
    burger.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>';
    actions.appendChild(burger);

    var overlay = document.createElement('div');
    overlay.className = 'sa-mnav-overlay';
    var drawer = document.createElement('aside');
    drawer.className = 'sa-mnav';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Menu');
    drawer.setAttribute('aria-hidden', 'true');

    var head = document.createElement('div');
    head.className = 'sa-mnav-head';
    head.innerHTML = '<span class="lbl">\u2605 the menu</span>';
    var x = document.createElement('button');
    x.className = 'sa-mnav-close';
    x.setAttribute('aria-label', 'Close menu');
    x.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    head.appendChild(x);
    drawer.appendChild(head);

    links.forEach(function (a) {
      var n = document.createElement('a');
      n.href = a.getAttribute('href');
      n.textContent = a.textContent.trim();
      drawer.appendChild(n);
    });

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    var last = null;
    var trapFn = trap(drawer);
    function open() {
      last = document.activeElement;
      overlay.classList.add('open'); drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var f = $$('a[href],button', drawer); if (f.length) f[0].focus();
      document.addEventListener('keydown', trapFn);
    }
    function close() {
      overlay.classList.remove('open'); drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', trapFn);
      if (last && last.focus) last.focus();
    }
    burger.addEventListener('click', open);
    x.addEventListener('click', close);
    overlay.addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target.tagName === 'A') close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
  }

  /* ============================================================
     2. CARD VIDEO ENGINE
     One video plays at a time. The active row is the one crossing the
     play-line; inside it, cards cycle left to right. Hovering a card
     takes over immediately. Reduced motion means posters only.
     ============================================================ */
  function initCardVideos() {
    if (!SA.cardVideo || reduced) return;
    var cards = $$('.sa-card').filter(function (c) { return $('video[data-sa-video]', c); });
    if (!cards.length) return;

    var PLAY_LINE = 0.45, BAND_TOP = 0.25, BAND_BOT = 0.70, DWELL = 2000, TOL = 40;
    var active = null, hover = null, rowKey = null, idx = 0, blocked = false;

    function rows() {
      var map = {};
      cards.forEach(function (c) {
        var top = Math.round((c.getBoundingClientRect().top + window.pageYOffset) / TOL) * TOL;
        (map[top] = map[top] || []).push(c);
      });
      return Object.keys(map).map(Number).sort(function (a, b) { return a - b; }).map(function (k) {
        return { key: k, cards: map[k].sort(function (a, b) { return a.getBoundingClientRect().left - b.getBoundingClientRect().left; }) };
      });
    }
    function fullyVisible(c) {
      var r = c.getBoundingClientRect(), vh = innerHeight;
      if (r.height > vh * 0.8) { var line = vh * PLAY_LINE; return r.top < line && r.bottom > line; }
      return r.top >= 0 && r.bottom <= vh;
    }
    function band(row) {
      var vh = innerHeight;
      var tops = row.cards.map(function (c) { return c.getBoundingClientRect().top; });
      var bots = row.cards.map(function (c) { return c.getBoundingClientRect().bottom; });
      var t = Math.min.apply(null, tops), b = Math.max.apply(null, bots);
      return { cross: t < vh * PLAY_LINE && b > vh * PLAY_LINE, inBand: b > vh * BAND_TOP && t < vh * BAND_BOT };
    }
    function stop() {
      if (!active) return;
      var v = $('video[data-sa-video]', active);
      active.classList.remove('playing');
      if (v) { try { v.pause(); } catch (e) {} }
      active = null;
    }
    function play(card) {
      if (card === active) return;
      stop();
      active = card;
      var v = $('video[data-sa-video]', card); if (!v) return;
      if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src);
      if (!v.getAttribute('src')) return;
      card.classList.add('playing');
      var p = v.play();
      if (p && p.catch) p.catch(function () { blocked = true; card.classList.remove('playing'); });
    }
    function tick() {
      if (hover) { play(hover); return; }
      var rs = rows(); if (!rs.length) return;
      var cur = null;
      if (rowKey !== null) cur = rs.filter(function (r) { return r.key === rowKey && band(r).inBand; })[0] || null;
      if (!cur) {
        cur = rs.filter(function (r) { return band(r).cross; })[0] || null;
        if (cur && cur.key !== rowKey) { rowKey = cur.key; idx = 0; }
      }
      if (!cur) { stop(); return; }
      var elig = cur.cards.filter(fullyVisible);
      if (!elig.length) { stop(); return; }
      play(elig[idx % elig.length]);
      idx = (idx + 1) % elig.length;
    }
    setInterval(tick, DWELL); tick();

    var pending = false;
    addEventListener('scroll', function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; tick(); });
    }, { passive: true });

    cards.forEach(function (c) {
      c.addEventListener('pointerenter', function () { hover = c; play(c); });
      c.addEventListener('pointerleave', function () { if (hover === c) { hover = null; tick(); } });
    });
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, function () { if (blocked) { blocked = false; tick(); } }, { once: true, passive: true });
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : tick(); });
  }

  /* ============================================================
     3. CART DRAWER + AJAX
     ============================================================ */
  function initCart() {
    var drawer = $('[data-sa-cart-drawer]');
    var backdrop = $('[data-sa-cart-backdrop]');

    function open() {
      if (!drawer) { location.href = SA.routes.cart; return; }
      drawer.classList.add('open');
      if (backdrop) backdrop.classList.add('open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', trapFn);
      var f = $$('button,a[href]', drawer); if (f.length) f[0].focus();
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('open');
      if (backdrop) backdrop.classList.remove('open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', trapFn);
    }
    var trapFn = drawer ? trap(drawer) : function () {};
    window.saOpenCart = open;

    $$('[data-sa-cart-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-sa-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) close();
    });

    function refresh() { location.reload(); }

    function changeLine(line, qty) {
      return fetch(SA.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { refresh(); });
    }

    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-sa-qty]');
      if (step) {
        var wrap = step.closest('[data-sa-line]');
        var line = parseInt(wrap.dataset.saLine, 10);
        var num = $('.num', step.parentElement);
        var next = parseInt(num.textContent, 10) + parseInt(step.dataset.saQty, 10);
        if (next < 0) next = 0;
        changeLine(line, next);
        return;
      }
      var rm = e.target.closest('[data-sa-remove]');
      if (rm) {
        var w = rm.closest('[data-sa-line]');
        changeLine(parseInt(w.dataset.saLine, 10), 0);
      }
    });

    var noteEl = $('[data-sa-cart-note]');
    if (noteEl) {
      var t;
      noteEl.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          fetch(SA.routes.cart_update, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteEl.value })
          });
        }, 600);
      });
    }
  }

  /* ============================================================
     4. PDP
     ============================================================ */
  function initProduct() {
    var pdp = $('[data-sa-product]'); if (!pdp) return;

    /* -- gallery -- */
    var thumbs = $$('[data-sa-thumb]');
    var mainImg = $('#mainImg');
    var counter = $('[data-sa-counter]');
    function selectThumb(i) {
      if (!thumbs.length) return;
      i = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('active', n === i);
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      if (mainImg) mainImg.src = thumbs[i].dataset.src;
      if (counter) counter.textContent = (i + 1) + ' / ' + thumbs.length;
      thumbs[i].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
    function currentThumb() {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
      return i < 0 ? 0 : i;
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectThumb(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectThumb(i); }
      });
    });
    $$('[data-sa-gallery-nav]').forEach(function (b) {
      b.addEventListener('click', function () { selectThumb(currentThumb() + parseInt(b.dataset.saGalleryNav, 10)); });
    });
    $$('[data-sa-thumbs-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var strip = $('#pdpThumbs');
        if (strip) strip.scrollBy({ left: parseInt(b.dataset.saThumbsScroll, 10) * 200, behavior: 'smooth' });
      });
    });
    var strip = $('#pdpThumbs');
    if (strip) {
      strip.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { strip.scrollLeft += e.deltaY; e.preventDefault(); }
      }, { passive: false });
    }
    /* gallery pills: filter the thumb strip by image alt text.
       A pill whose keyword matches no image is hidden, so type-specific
       pills disappear on products that have no such photo. */
    var pills = $$('[data-sa-pill]');
    if (pills.length && thumbs.length) {
      var alts = thumbs.map(function (t) {
        var im = t.querySelector('img');
        return ((im && im.getAttribute('alt')) || '').toLowerCase();
      });
      var anyVisible = false;
      pills.forEach(function (p) {
        var key = (p.dataset.match || '').trim().toLowerCase();
        var hits = key ? alts.filter(function (a) { return a.indexOf(key) > -1; }).length : thumbs.length;
        if (!hits) { p.hidden = true; return; }
        anyVisible = true;
        p.addEventListener('click', function () {
          pills.forEach(function (x) { x.classList.remove('active'); });
          p.classList.add('active');
          var firstShown = -1;
          thumbs.forEach(function (t, i) {
            var show = !key || alts[i].indexOf(key) > -1;
            t.hidden = !show;
            if (show && firstShown < 0) firstShown = i;
          });
          if (firstShown > -1) selectThumb(firstShown);
        });
      });
      /* only one pill left and it shows everything? then it is not a filter */
      var shown = pills.filter(function (p) { return !p.hidden; });
      if (!anyVisible || shown.length < 2) shown.forEach(function (p) { p.hidden = true; });
    }

    /* -- variants -- */
    var variants = [];
    var vjson = $('[data-sa-variants]');
    if (vjson) { try { variants = JSON.parse(vjson.textContent); } catch (e) {} }

    function selectedOptions() {
      return $$('[data-sa-option-wrap]').map(function (w) {
        var on = $('[data-sa-option-btn][aria-pressed="true"]', w);
        return on ? on.dataset.value : null;
      });
    }
    function matchVariant() {
      var sel = selectedOptions();
      return variants.filter(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }
    function applyVariant() {
      var v = matchVariant();
      var idInput = $('[data-sa-variant-id]');
      var atc = $('[data-sa-atc]');
      var priceEl = $('[data-sa-price]');
      var cmpEl = $('[data-sa-compare]');
      var stockEl = $('[data-sa-stock]');
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) cmpEl.textContent = v.compare_at_price && v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      if (stockEl) stockEl.textContent = v.available ? stockEl.dataset.inLabel || stockEl.textContent : 'sold out \u00b7 fresh batch soon';
      if (atc) {
        atc.disabled = !v.available;
        syncAtcLabel();
      }
      var url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sa-option-btn]');
      if (!btn) return;
      var wrap = btn.closest('[data-sa-option-wrap]');
      $$('[data-sa-option-btn]', wrap).forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('on', 'selected');
      });
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add(btn.classList.contains('pdp-sw') ? 'on' : 'selected');
      var lbl = $('[data-sa-option-value]', wrap);
      if (lbl) lbl.textContent = btn.dataset.value;
      applyVariant();
    });

    /* -- quantity -- */
    var qtyNum = $('[data-sa-qty-num]');
    var qtyInput = $('[data-sa-qty-input]');
    function syncAtcLabel() {
      var atc = $('[data-sa-atc]'); if (!atc || atc.dataset.busy) return;
      var v = matchVariant(); if (!v) return;
      if (!v.available) { atc.textContent = atc.dataset.soldLabel || 'join the waitlist \u2726'; return; }
      var q = qtyNum ? parseInt(qtyNum.textContent, 10) : 1;
      atc.textContent = (atc.dataset.label || 'add to cart') + ' \u00b7 ' + money(v.price * q) + ' \u2192';
      var sp = $('[data-sa-sticky-price]'); if (sp) sp.textContent = money(v.price * q);
    }
    var atcEl = $('[data-sa-atc]');
    if (atcEl) {
      atcEl.dataset.label = (atcEl.textContent || '').split('\u00b7')[0].trim() || 'add to cart';
    }
    $$('[data-sa-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qtyNum.textContent, 10) + parseInt(b.dataset.saQtyStep, 10);
        if (n < 1) n = 1;
        qtyNum.textContent = n;
        if (qtyInput) qtyInput.value = n;
        var dec = $('[data-sa-qty-step="-1"]');
        if (dec) dec.disabled = n <= 1;
        syncAtcLabel();
      });
    });

    /* -- add to cart -- */
    var form = $('[data-sa-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atc = $('[data-sa-atc]');
        var err = $('[data-sa-atc-error]');
        if (!atc || atc.disabled) return;
        atc.dataset.busy = '1';
        atc.disabled = true;
        atc.setAttribute('aria-busy', 'true');
        var restore = atc.textContent;
        atc.textContent = 'adding\u2026';
        if (err) err.hidden = true;

        fetch(SA.routes.cart_add, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d.description || res.d.message || 'could not add that bite');
            atc.textContent = '\u2726 added to your stash!';
            var badge = $('[data-sa-cart-count]');
            if (badge) badge.textContent = parseInt(badge.textContent, 10) + (qtyNum ? parseInt(qtyNum.textContent, 10) : 1);
            setTimeout(function () {
              delete atc.dataset.busy; atc.disabled = false; atc.removeAttribute('aria-busy');
              atc.textContent = restore;
              if (window.saOpenCart) { location.reload(); }
            }, 700);
          })
          .catch(function (ex) {
            delete atc.dataset.busy; atc.disabled = false; atc.removeAttribute('aria-busy');
            atc.textContent = restore;
            if (err) { err.textContent = ex.message + ' \u2014 give it another tap?'; err.hidden = false; }
          });
      });
    }
    var sticky = $('[data-sa-sticky-buy]');
    if (sticky && form) sticky.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });

    /* -- share / wishlist -- */
    var share = $('[data-sa-share]');
    if (share) {
      share.addEventListener('click', function () {
        var url = share.dataset.shareUrl, title = share.dataset.shareTitle;
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); }
        else {
          navigator.clipboard && navigator.clipboard.writeText(url);
          var t = share.textContent; share.textContent = '\u2726 link copied!';
          setTimeout(function () { share.textContent = t; }, 1400);
        }
      });
    }
    var wish = $('[data-sa-wishlist]');
    if (wish) {
      var KEY = 'sa_wishlist';
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      var h = wish.dataset.product;
      function paint() { wish.classList.toggle('on', list.indexOf(h) > -1); }
      paint();
      wish.addEventListener('click', function () {
        var i = list.indexOf(h);
        if (i > -1) list.splice(i, 1); else list.push(h);
        localStorage.setItem(KEY, JSON.stringify(list));
        paint();
      });
    }

    /* -- hide the reviews block if no app filled it -- */
    var rev = $('[data-sa-reviews]');
    if (rev) {
      var mount = rev.querySelector('#judgeme_product_reviews, [data-oke-widget]');
      setTimeout(function () {
        if (!mount || mount.children.length === 0) rev.hidden = true;
      }, 2500);
    }

    /* -- record recently viewed -- */
    recordRecentlyViewed(pdp.dataset);

    /* -- product recommendations (section render) -- */
    var rec = $('[data-sa-recommendations]');
    if (rec && rec.dataset.url) {
      fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sa-recommendations]');
        if (fresh) rec.innerHTML = fresh.innerHTML;
        initCardVideos();
      }).catch(function () {});
    }
  }

  /* ============================================================
     5. CLOSURE GUIDE MODAL
     ============================================================ */
  function initGuide() {
    var overlay = $('[data-sa-guide-modal]');
    var frame = $('[data-sa-guide-frame]');
    var opener = $('[data-sa-guide-open]');
    if (!overlay || !frame) return;
    var trapFn = trap(overlay);

    function open(url) {
      if (!frame.getAttribute('src')) {
        frame.setAttribute('src', url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=embed');
      }
      overlay.hidden = false;
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', trapFn);
    }
    function close() {
      overlay.classList.remove('open');
      overlay.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', trapFn);
    }
    if (opener) opener.addEventListener('click', function (e) { e.preventDefault(); open(opener.dataset.guideUrl); });
    $$('[data-sa-guide-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

    /* the guide iframe posts the chosen closure back up to the PDP */
    addEventListener('message', function (e) {
      if (!e.data || e.data.type !== 'sa:selectClosure') return;
      var val = e.data.value;
      var btn = $$('[data-sa-option-btn]').filter(function (b) { return b.dataset.value === val; })[0];
      if (btn) btn.click();
      close();
    });
  }

  /* the guide page itself, when embedded, posts its selection upward */
  function initGuideSelect() {
    $$('[data-sa-guide-select]').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = b.dataset.value;
        if (parent !== window) parent.postMessage({ type: 'sa:selectClosure', value: val }, '*');
        else {
          b.textContent = '\u2726 noted \u2014 pick it on any product';
        }
      });
    });
  }

  /* ============================================================
     6. RECENTLY VIEWED
     ============================================================ */
  var RV_KEY = 'sa_recently_viewed';
  function recordRecentlyViewed(d) {
    if (!d || !d.productHandle) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
    list = list.filter(function (p) { return p.handle !== d.productHandle; });
    list.unshift({ handle: d.productHandle, title: d.productTitle, image: d.productImage, price: d.productPrice, url: d.productUrl });
    localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
  }
  function renderRecentlyViewed() {
    var wraps = $$('[data-sa-recently-viewed]');
    if (!wraps.length) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
    var here = $('[data-sa-product]');
    var skip = here ? here.dataset.productHandle : null;
    list = list.filter(function (p) { return p.handle !== skip; }).slice(0, SA.recentlyViewedLimit || 5);
    wraps.forEach(function (w) {
      var row = $('[data-sa-rv-row]', w);
      if (!row) return;
      if (!list.length) {
        w.hidden = true; w.dataset.empty = 'true';
        var sec = w.closest('section.sec, .sec');
        if (sec && sec !== w && !sec.querySelector('.sa-card, .gr-grid, .drops')) sec.hidden = true;
        return;
      }
      row.innerHTML = list.map(function (p) {
        return '<a class="sa-rv-card" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
          '<span><span class="nm">' + p.title + '</span><span class="pr">' + (p.price || '') + '</span></span></a>';
      }).join('');
      w.hidden = false;
      w.dataset.empty = 'false';
    });
  }

  /* ============================================================
     7. ODDS AND ENDS
     ============================================================ */
  function initSignups() {
    $$('form.sa-signup').forEach(function (form) {
      var input = form.querySelector('input[type=email]');
      var btn = form.querySelector('button');
      var err = form.parentElement.querySelector('.sa-signup-err') || form.querySelector('.sa-signup-err');
      if (!input || !btn) return;
      form.addEventListener('submit', function (e) {
        var v = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
          e.preventDefault();
          input.setAttribute('aria-invalid', 'true');
          if (err) { err.textContent = 'hmm, that email looks half-baked \u2014 double-check it?'; err.style.display = 'block'; }
          return;
        }
        input.setAttribute('aria-invalid', 'false');
        if (err) err.style.display = 'none';
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'subscribing\u2026';
      });
    });
  }

  function initCopyButtons() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sa-copy]');
      if (!b) return;
      var val = b.dataset.saCopy;
      if (navigator.clipboard) navigator.clipboard.writeText(val);
      var t = b.textContent;
      b.textContent = '\u2726 copied!';
      setTimeout(function () { b.textContent = t; }, 1400);
    });
  }

  function initLegalToc() {
    var src = $('[data-sa-toc-source]');
    var list = $('[data-sa-toc-list]');
    if (!src || !list) return;
    var hs = $$('h2, h3', src);
    if (!hs.length) { var toc = $('[data-sa-toc]'); if (toc) toc.hidden = true; return; }
    list.innerHTML = hs.map(function (h, i) {
      if (!h.id) h.id = 'sec-' + i + '-' + (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 40);
      return '<a href="#' + h.id + '" class="lvl-' + h.tagName.toLowerCase() + '">' + h.textContent + '</a>';
    }).join('');
  }

  function initFilters() {
    var form = $('[data-sa-filter-form]');
    if (!form) return;
    form.addEventListener('change', function () {
      var params = new URLSearchParams();
      $$('input[type=checkbox]:checked, input[type=number], select', form).forEach(function (el) {
        if (el.value) params.append(el.name, el.value);
      });
      location.search = params.toString();
    });
  }

  function initEmbedMode() {
    var p = new URLSearchParams(location.search);
    if (p.get('view') === 'embed') document.body.classList.add('sa-embed');
  }

  ready(function () {
    initEmbedMode();
    initMobileNav();
    initCart();
    initProduct();
    initGuide();
    initGuideSelect();
    renderRecentlyViewed();
    initSignups();
    initCopyButtons();
    initLegalToc();
    initFilters();
    initCardVideos();
  });
})();

/* ---------- coupons page: filter chips + sort ---------- */
(function(){
  var grid = document.querySelector('.cp-tickets');
  if (!grid) return;
  var chips = document.querySelectorAll('[data-cp-filter]');
  var sort = document.querySelector('[data-cp-sort]');

  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      chips.forEach(function(c){ c.classList.remove('is-on'); });
      chip.classList.add('is-on');
      var want = chip.getAttribute('data-cp-filter');
      grid.querySelectorAll('.cp-tk').forEach(function(tk){
        var st = tk.getAttribute('data-cp-state') || 'fresh';
        tk.hidden = (want !== 'all' && st !== want);
      });
    });
  });

  if (sort) sort.addEventListener('change', function(){
    var mode = sort.value;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.cp-tk'));
    if (mode === 'value') {
      cards.sort(function(a,b){
        return (parseFloat(b.dataset.cpValue) || 0) - (parseFloat(a.dataset.cpValue) || 0);
      });
    } else if (mode === 'expiry') {
      /* cards carrying a corner badge (e.g. "3 days left!") float up */
      cards.sort(function(a,b){
        return (b.querySelector('.cp-tk-warn') ? 1 : 0) - (a.querySelector('.cp-tk-warn') ? 1 : 0);
      });
    }
    cards.forEach(function(c){ grid.appendChild(c); });
  });
})();

/* ---------- header dropdowns: hover on desktop, click/keyboard always ---------- */
(function(){
  var groups = document.querySelectorAll('.sa-nav-group');
  if (!groups.length) return;
  var desktop = window.matchMedia('(min-width:901px)');

  function closeAll(except){
    groups.forEach(function(g){
      if (g === except) return;
      g.classList.remove('is-open');
      var t = g.querySelector('.sa-nav-toggle');
      if (t) t.setAttribute('aria-expanded','false');
    });
  }

  groups.forEach(function(g){
    var toggle = g.querySelector('.sa-nav-toggle');
    if (!toggle) return;

    var closeTimer = null;
    function open(){
      clearTimeout(closeTimer);
      closeAll(g); g.classList.add('is-open'); toggle.setAttribute('aria-expanded','true');
    }
    function close(){
      clearTimeout(closeTimer);
      g.classList.remove('is-open'); toggle.setAttribute('aria-expanded','false');
    }
    /* grace period: crossing the gap or clipping a corner should not close it */
    function closeSoon(){
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 260);
    }

    toggle.addEventListener('click', function(e){
      e.preventDefault();
      g.classList.contains('is-open') ? close() : open();
    });

    /* hover only where there is a pointer and room for a floating menu */
    g.addEventListener('pointerenter', function(e){
      if (e.pointerType === 'touch' || !desktop.matches) return;
      open();
    });
    g.addEventListener('pointerleave', function(e){
      if (e.pointerType === 'touch' || !desktop.matches) return;
      closeSoon();
    });
    /* re-entering anywhere in the group (toggle, bridge, or menu) cancels the close */
    g.addEventListener('pointerover', function(){ clearTimeout(closeTimer); });

    /* leaving the group by keyboard closes it */
    g.addEventListener('focusout', function(e){
      if (!g.contains(e.relatedTarget)) close();
    });
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeAll(null);
  });
  document.addEventListener('click', function(e){
    if (!e.target.closest('.sa-nav-group')) closeAll(null);
  });
})();

/* ---------- studio films: per-block playback speed ---------- */
(function(){
  var wells = document.querySelectorAll('.ab-film-well[data-sa-speed]');
  if (!wells.length) return;

  wells.forEach(function(well){
    var rate = parseFloat(well.getAttribute('data-sa-speed'));
    if (!rate || rate === 1) return;

    function apply(v){
      try { v.playbackRate = rate; } catch(e) {}
      /* some browsers reset the rate when the source (re)loads */
      v.addEventListener('loadedmetadata', function(){ try { v.playbackRate = rate; } catch(e) {} });
      v.addEventListener('play', function(){ try { v.playbackRate = rate; } catch(e) {} });
    }

    var v = well.querySelector('video');
    if (v) { apply(v); return; }

    /* Shopify may inject the <video> after first paint (deferred media) */
    var mo = new MutationObserver(function(){
      var late = well.querySelector('video');
      if (late) { apply(late); mo.disconnect(); }
    });
    mo.observe(well, { childList: true, subtree: true });
  });
})();
